import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-[#eeeeee] text-gray-600 overflow-x-hidden">
      <div className="max-w-7xl mx-auto px-8 py-12">
        {/* 1행: 로고 좌상단 — 4컬럼 그리드 좌측 축과 시각 정렬 */}
        <div className="mb-10">
          <img
            src="/logo-full.png"
            alt="동두천시 글로벌인재교육센터"
            className="h-12 w-auto"
          />
        </div>

        {/* 2행: 4컬럼 — 한글정보·영문정보(각 2fr) + 빠른링크·고객지원(각 1fr) */}
        <div className="grid grid-cols-1 md:grid-cols-[2fr_2fr_1fr_1fr] gap-8 md:gap-10 mb-10">
          {/* 한글 기관정보 */}
          <div className="space-y-2 text-sm">
            <p className="text-gray-800 font-semibold text-base">(주)한원글로벌 동두천지점</p>
            <p>대표자: 김한경</p>
            <p className="leading-relaxed">
              주소: 경기도 동두천시 동두천로 97, 2층<br />
              (지행동, 동두천싸이언스타워)
            </p>
            <p>
              이메일: <a href="mailto:korea@hanwonglobal.com" className="hover:text-green-600 transition-colors">korea@hanwonglobal.com</a>
            </p>
            <p>
              Tel: <a href="tel:031-866-5670" className="hover:text-green-600 transition-colors">031-866-5670</a>
            </p>
            <p>Fax: 031-866-5671</p>
          </div>

          {/* 영문 기관정보 */}
          <div className="space-y-2 text-sm">
            <p className="text-gray-800 font-semibold text-base">
              Hanwon Global Co., Ltd.<br />
              Dongducheon Global Talent Center
            </p>
            <p>CEO: Kim, Hangyeong</p>
            <p className="leading-relaxed">
              Address: 2F, 97 Dongducheon-ro,<br />
              Dongducheon-si, Gyeonggi-do,<br />
              Republic of Korea
            </p>
            <p>
              Email: <a href="mailto:korea@hanwonglobal.com" className="hover:text-green-600 transition-colors">korea@hanwonglobal.com</a>
            </p>
            <p>
              Tel: <a href="tel:+82318665670" className="hover:text-green-600 transition-colors">+82-31-866-5670</a>
            </p>
            <p>Fax: +82-31-866-5671</p>
          </div>

          {/* 빠른 링크 */}
          <div>
            <h3 className="text-gray-800 font-bold text-base mb-3">빠른 링크</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about/greeting" className="hover:text-green-600 transition-colors">센터소개</Link>
              </li>
              <li>
                <Link to="/curriculum" className="hover:text-green-600 transition-colors">교육과정</Link>
              </li>
              <li>
                <Link to="/notice" className="hover:text-green-600 transition-colors">공지사항</Link>
              </li>
              <li>
                <Link to="/about/location" className="hover:text-green-600 transition-colors">오시는 길</Link>
              </li>
            </ul>
          </div>

          {/* 고객지원 */}
          <div>
            <h3 className="text-gray-800 font-bold text-base mb-3">고객지원</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/community/faq" className="hover:text-green-600 transition-colors">자주묻는 질문</Link>
              </li>
              <li>
                <Link to="/application/register" className="hover:text-green-600 transition-colors">수강신청</Link>
              </li>
              <li>
                <Link to="/mypage" className="hover:text-green-600 transition-colors">마이페이지</Link>
              </li>
            </ul>
          </div>
        </div>

        {/* 3행: 카피라이트(좌) ↔ SNS(우) — 바닥 무게중심 */}
        <div className="border-t border-gray-300 pt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-sm text-gray-500 text-center md:text-left">
            &copy; {new Date().getFullYear()} Dongducheon Global Talent Center. All rights reserved.
          </p>
          <div className="flex items-center gap-3 justify-center md:justify-end">
            <a
              href="https://www.youtube.com/@ddcglobalcenter"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-70 transition-opacity"
              aria-label="YouTube"
            >
              <img src="/youtube.png" alt="YouTube" className="h-9 w-auto object-contain" />
            </a>
            <a
              href="https://www.instagram.com/help.dgtc/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-70 transition-opacity"
              aria-label="Instagram"
            >
              <img src="/instagram.png" alt="Instagram" className="h-14 w-auto object-contain" />
            </a>
            <a
              href="http://pf.kakao.com/_xdWzpn"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-70 transition-opacity"
              aria-label="KakaoTalk"
            >
              <img src="/kakaotalk-new.png" alt="KakaoTalk" className="h-8 w-auto object-contain" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
